/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ComponentOverride } from '../../forms/EnvironmentVariableForm/elements/OverridesAccordion/OverridesAccordion.defs';
import { OverridesAccordionProps } from '../../forms/EnvironmentVariableForm/elements/OverridesAccordion/OverridesAccordion.props';

/**
 * Finds the environment variables that are being overridden by the components within the set.
 */
export const findComponentOverrides = ({ componentSet }: OverridesAccordionProps): Array<ComponentOverride> => {
  const setEnvVarMap = componentSet.environmentVariables || {};
  const componentOverrides: Array<ComponentOverride> = [];

  // For every component on the component set
  Object.entries(componentSet.components).forEach(([componentName, componentObject]) => {
    const componentVersion = componentObject[0].version;
    const componentEnvironmentVariables = componentObject[0].environmentVariables || {};
    const matchingVariables: Array<Record<string, string>> = [];

    // We want to find the matching environment variables that are component set in the map.
    Object.entries(componentEnvironmentVariables).forEach(([cmpEnvVarKey, cmpEnvVarValue]) => {
      if (cmpEnvVarKey in setEnvVarMap) {
        matchingVariables.push({ [cmpEnvVarKey]: cmpEnvVarValue });
      }
    });
    if (matchingVariables.length > 0) {
      componentOverrides.push({
        componentName: componentName,
        componentVersion: componentVersion,
        variables: matchingVariables,
      });
    }
  });
  return componentOverrides;
};
